// extracted by mini-css-extract-plugin
export var containerVideo = "video-banner-module--containerVideo --d44f2";
export var content = "video-banner-module--content--d0f88";
export var image = "video-banner-module--image--05938";
export var section = "video-banner-module--section--9b054";
export var videoWrapper = "video-banner-module--videoWrapper--bb8f8";